import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { PromiseSection } from './components/PromiseSection';
import { ChaptersSection } from './components/ChaptersSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { AuthorSection } from './components/AuthorSection';
import { PriceSection } from './components/PriceSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="w-full min-h-screen" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <PromiseSection data-id="element-3" />
      <ChaptersSection data-id="element-4" />
      <BonusesSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <ForWhomSection data-id="element-7" />
      <AuthorSection data-id="element-8" />
      <PriceSection data-id="element-9" />
      <FaqSection data-id="element-10" />
      <FinalCta data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}